import { format, parseISO } from "date-fns";
import { Storage } from "./Storage";
import { Reservation } from "./Reservation";
import constants from "../../../utils/constants";
export class BookingCart {
    static getFromSessionStorage() {
        return Storage.fromSessionStorage(constants.LOCAL_STORAGE_KEYS.CART);
    }
    static saveToSessionStorage(data) {
        return Storage.saveOnSessionStorage(constants.LOCAL_STORAGE_KEYS.CART, data);
    }
    static isEmpty() {
        const propertiesCarts = [];
        const sessionData = this.getFromSessionStorage();
        if (!sessionData) {
            return true;
        }
        for (const [, value] of Object.entries(sessionData)) {
            propertiesCarts.push(value.length === 0);
        }
        return propertiesCarts.every(it => it);
    }
    static getReservations() {
        return this.getFromSessionStorage();
    }
    static saveReservations(data) {
        const booking = data.reduce((bookings, it) => {
            (bookings[it.propertyTicker] = bookings[it.propertyTicker] || []).push({
                id: it.id,
                startDate: format(parseISO(it.start), "yyyy-MM-dd"),
                endDate: format(parseISO(it.end), "yyyy-MM-dd"),
                numberOfUnits: it.numberOfUnits,
                inventory: it.inventory,
                propertyTicker: it.propertyTicker,
                selectedServices: it.services || {},
            });
            return bookings;
        }, {});
        this.saveToSessionStorage(booking);
        return booking;
    }
    static getReservationsAsComparableString() {
        const bookingReservations = this.getReservations();
        if (bookingReservations) {
            return Reservation.getAsString(bookingReservations);
        }
    }
}
